
module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill-rule=\"evenodd\"><path class=\"rich-link__arrow-icon\" d=\"m12 0c-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12 6.627 0 12-5.373 12-12 0-6.627-5.373-12-12-12m.21 19l-.637-.668 4.888-6.326h-11.465v-1.01h11.465l-4.888-6.333.637-.668 6.79 7.158v.685l-6.79 7.157\"/></g>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
